export const Autocomplete = {
    name: 'autocomplete',
    props: {
        items: {
            type: Array,
            required: false,
            default: () => [],
        },
        isAsync: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            isOpen: false,
            results: [],
            search: '',
            isLoading: false,
            arrowCounter: 0,
        };
    },

    methods: {
        filterResults() {
            this.results = this.items.filter((item) => {
                return item.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
            });
        },
        setResult(result) {
            this.search = result;
            this.$emit('selected', this.search);
            this.search = "";
            this.isOpen = false;
        },
        onArrowDown() {
            if (this.arrowCounter < this.results.length) {
                this.arrowCounter = this.arrowCounter + 1;
            }
        },
        onArrowUp() {
            if (this.arrowCounter > 0) {
                this.arrowCounter = this.arrowCounter - 1;
            }
        },
        onEnter() {
            if (this.arrowCounter >= 0 && this.arrowCounter < this.results.length) {
                this.search = this.results[this.arrowCounter];
            }
            this.$emit("selected", this.search);
            this.isOpen = false;
            this.arrowCounter = -1;
            this.search = "";
        },
        handleClickOutside(target, element) {
            if (element && !element.contains(target)) {
                this.isOpen = false;
                this.arrowCounter = -1;
            }
        }
    }
};
